import { Fragment, useEffect, useState } from 'react';
import MultiSelect from 'components/common/MultiSelectCheckbox/BinderV4Field';
import { datasourceOverrider, getOverriderNoDefault } from 'common/util/binderHelpers';
import { get, isArray, isEmpty, isString } from 'lodash';
import DocumentDrivingDetailIcon from 'components/common/DocumentDrivingDetailIcon/index';


export default function Index({
    data,
    overrides,
    dataSources,
    canAddDataSource,
    essentials,
    handleDetailsChange,
    handleEssetialsChange,
    study
}) {
    const [listOfFields, setListOdFields] = useState([]);
    useEffect(() => {
        //Identify document driving details  and remove them
        const documentDrivingDetailsOverride = overrides.filter(dt => data.some(el => el.dataSourceId === dt.dataSourceId));

        //Remove already displayed overrides
        let clearedFields = essentials.filter(field => !documentDrivingDetailsOverride.some(el => el.label === field.label));

        //Sponsor and trail id were already diplay in step 1, lets remove them
        const list = clearedFields.slice(2);

        const fieldsWithDatasourceId = list.map(field => {
            const [options] = dataSources.filter(el => el.name === getOverridesLabel(field.label));
            const inputFieldType = hasOverride(field.label) || field.inputFieldType.includes('date') ? field.inputFieldType : '';
            return {
                ...field,
                ...options,
                inputFieldType,
            };
        });

        setListOdFields(fieldsWithDatasourceId);
    }, [overrides, essentials, study]);

    function getStudyEssentialsValue(field) {
        const existingEssentials = get(study, 'fields.studyEssentials', []);
        const [existingValue] = existingEssentials.filter(essential => essential.name === field.baseName);
        const value = existingValue ? existingValue.value : '';
        return value;
    }

    function getOptions(id) {
        const [dataSourceValues] = dataSources.filter(dt => dt.id === id);

        let value = dataSourceValues && dataSourceValues.parameters && dataSourceValues.parameters.values;

        if (!isEmpty(value)) {
            value = value.map(el => ({ ...el, chipLabel: el.text }));
        }

        return value;

    }

    function getOverridesLabel(selector) {
        const overridingLabel = datasourceOverrider(selector, overrides, dataSources);

        if (!overridingLabel) {
            return selector;
        }

        return overridingLabel;
    }

    function hasOverride(selector) {
        const override = getOverriderNoDefault(selector, overrides, dataSources);
        return !!override;
    }

    function fieldType(field) {
        let type = 'input';
        const isOverride = overrides.some(el => el.label === field);

        if (isOverride) {
            type = 'select';
        }

        return type;
    }

    function getPlaceHolder(selector) {
        const prefix = fieldType(selector) === 'select' ? 'Select' : 'Enter';

        return `${prefix} ${getOverridesLabel(selector)}`;
    }

    function getDataValue(field) {
        if (isString(field.value)) {
            return field.value;
        }
    }

    function getDataChipData(field) {
        if (isString(field.value)) return;

        if (field.value && !isArray(field.value)) {
            return Array(field.value);
        }
        return field.value;
    }

    function getDataSourceIdBySelector(selector) {
        const [dataSourceValues] = dataSources.filter(dt => dt.name === selector);

        if (dataSourceValues) {
            return dataSourceValues.id;
        }
    }

    return (
        <Fragment>
            <p>Details</p>
            {
                data && data.map((field, index) => (
                    <MultiSelect
                        key={field.dataSourceId || `${field.name}_${index}`}
                        label={field.name}
                        placeholder={`Select ${field.name}`}
                        options={getOptions(field.dataSourceId)}
                        onSelectedOption={(value) => handleDetailsChange(field.descriptorId, value)}
                        onChange={(value) => handleDetailsChange(field.descriptorId, value)}
                        Tooltip={DocumentDrivingDetailIcon}
                        value={getDataValue(field)}
                        chipData={getDataChipData(field)}
                        canAddDataSource={canAddDataSource}
                        type={field.inputFieldType}
                        showCreateField={true}
                        datasourceId={field.dataSourceId}
                        instructions={field.instructions}
                        shouldBeAllValuesSelected={field.shouldBeAllValuesSelected}
                    />
                ))
            }
            {
                listOfFields.length && listOfFields.map((field, index) => (
                    <MultiSelect
                        key={`${index}_${field.label}`}
                        label={getOverridesLabel(field.label)}
                        options={getOptions(field.id)}
                        placeholder={`${getPlaceHolder(field.label)}`}
                        canAddDataSource={canAddDataSource}
                        showCreateField={true}
                        value={getStudyEssentialsValue(field)}
                        onChange={(value) => handleEssetialsChange(field.baseName, value)}
                        onSelectedOption={(value) => handleEssetialsChange(field.baseName, value)}
                        type={field.inputFieldType}
                        datasourceId={getDataSourceIdBySelector(getOverridesLabel(field.label))}
                    />
                ))
            }
        </Fragment>
    );
}